<template>
  <VaNavbar class="app-layout-navbar px-0">
    <template #left>
      <div class="left">
        <Transition v-if="isMobile" name="icon-fade" mode="out-in">
          <VaIcon
            class="mobile-menu-toggle"
            color="primary"
            :name="isSidebarMinimized ? 'menu' : 'close'"
            size="24px"
            @click="isSidebarMinimized = !isSidebarMinimized"
          />
        </Transition>
        <RouterLink to="/" class="navbar-logo-link" aria-label="Visit home page">
          <VuesticLogo :inline="true" :height="isMobile ? 34 : 42" />
        </RouterLink>
      </div>
    </template>
    <template #right>
      <AppNavbarActions class="app-navbar__actions" :is-mobile="isMobile" />
    </template>
  </VaNavbar>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useGlobalStore } from '../../stores/global-store'
import AppNavbarActions from './components/AppNavbarActions.vue'
import VuesticLogo from '../VuesticLogo.vue'

defineProps({
  isMobile: { type: Boolean, default: false },
})

const GlobalStore = useGlobalStore()

const { isSidebarMinimized } = storeToRefs(GlobalStore)
</script>

<style lang="scss" scoped>
.va-navbar {
  z-index: 2;
  width: 100%;
  min-height: 76px;
  padding: 10px;

  :deep(.va-navbar__content) {
    width: 100%;
    gap: 1rem;
    align-items: center;
    padding: 0.875rem 1.25rem;
  }

  :deep(.va-navbar__left),
  :deep(.va-navbar__right) {
    min-width: 0;
  }

  :deep(.va-navbar__left) {
    flex: 1 1 auto;
  }

  :deep(.va-navbar__right) {
    display: flex;
    justify-content: flex-end;
    flex: 0 1 auto;
  }

  @media screen and (max-width: 950px) {
    min-height: 68px;

    :deep(.va-navbar__content) {
      gap: 0.75rem;
      padding: 0.75rem 0.875rem;
    }
  }

  @media screen and (max-width: 640px) {
    min-height: 60px;

    :deep(.va-navbar__content) {
      gap: 0.5rem;
      padding: 0.625rem 0.75rem;
    }
  }
}

.left {
  display: flex;
  align-items: center;
  gap: 0.875rem;
  min-width: 0;
  flex: 1 1 auto;
}

.mobile-menu-toggle {
  margin-top: 0;
  flex-shrink: 0;
  cursor: pointer;
}

.navbar-logo-link {
  min-width: 0;
  display: inline-flex;
  align-items: center;
}

@media screen and (max-width: 640px) {
  .left {
    gap: 0.625rem;
  }

  .mobile-menu-toggle {
    transform: scale(0.95);
  }
}

.icon-fade-enter-active,
.icon-fade-leave-active {
  transition: transform 0.5s ease;
}

.icon-fade-enter,
.icon-fade-leave-to {
  transform: scale(0.5);
}
</style>
